import '@patsnap-biz/country-flag/lib/style/country.scss'
import '@patsnap-biz/country-flag/lib/style/country_flag.scss'

export function transformCountryNameToClass(name: string): string {
  const formatName = name.replace(/[\s|(|)|\-|'|,|.]/g, '_')
  return `patsnap-biz-country_flag__icon-${formatName}`
}
